<div class="advanced-filters">
  <div style="display: flex">
    <pdq-button
      icon="user_avatar"
      iconColor="var(--on-surface-light)"
      label="Mentions {{ selectedMentions?.length ? '/ ' + selectedMentions.length : '' }}"
      variant="ghost"
      [active]="selectedMentions?.length || isOpenMenu"
      [disabled]="disabled"
      pdqPopover
      [popoverTemplate]="userCollaboration"
      (click)="$event.stopImmediatePropagation()"
      [matTooltip]="'User mentions'"
      matTooltipClass="pdq-mat-tooltip"
      matTooltipPosition="above">
    </pdq-button>
  </div>

  <ng-template #userCollaboration>
    <pdq-popover-container [loading]="false">
      <div class="options-list-container">
        <pdq-options-list [options]="usersList" [multiple]="true" (onMultipleChange)="onUserMentionSelected($event)">
        </pdq-options-list>
      </div>
    </pdq-popover-container>
  </ng-template>
</div>
